import { render, staticRenderFns } from "./AddAnnouncement.vue?vue&type=template&id=a6a977b2&scoped=true&"
import script from "./AddAnnouncement.vue?vue&type=script&lang=js&"
export * from "./AddAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a977b2",
  null
  
)

export default component.exports